module.exports = __webpack_public_path__ + "img/39.a8484b5b.gif";